import { User } from "../../types";
import { getAxiosInstance, UserGroup } from "./constants";
import { TrendAnalysisColorApiResponse } from "../../interface/TrendAnalysisColorInterface";

export const getTrendAnalysisColorsByMetaPostId = async (
  metaPostId: string,
  currentUser: User | null
): Promise<TrendAnalysisColorApiResponse> => {
  if (!currentUser?.group) {
    throw new Error("User is not available");
  }

  const axiosInstance = getAxiosInstance(currentUser.group as UserGroup);
  const response = await axiosInstance.get<TrendAnalysisColorApiResponse>(
    `trend-analysis-colors/${encodeURIComponent(metaPostId)}`
  );
  return response.data;
};
